import axios from 'axios';

import cfac22 from '../cfac22';

export function login(cellphone, linkedAccount) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      post(
        cfac22('API_HOST_V2') + '/login',
        {
          cellphone,
          linkedAccount
        },
        {
          headers: { 'Full-Url': window.location.href }, withCredentials: true
        }
      ).
      then((result) => {
        //console.log('RESULTADO LOGIN ===>', result);
        resolve(result);
      }).
      catch((error) => {
        //console.log('ERROR LOGIN ===>', error);
        reject(error);
      });
    }).
    catch((error) => {
      reject(error);
    });
  });
}
